export function useCycleCounter(start: number, end: number) {
  const current = ref(start)

  function increment() {
    current.value = (current.value % end) + 1
  }

  return {
    current,
    increment,
  }
}
